import React from 'react';
import { AlertCircle } from 'lucide-react';

const SubscriptionDetails = ({ theme, permissions, onChange }) => {
  const fieldStyle = {
    width: "100%",
    padding: "8px 12px",
    borderRadius: "6px",
    border: theme === "light" ? "1px solid #cbd5e1" : "1px solid rgba(255,255,255,0.2)",
    background: theme === "light" ? "#ffffff" : "rgba(255,255,255,0.05)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "14px",
  };

  const labelStyle = {
    display: "block",
    fontSize: "12px",
    fontWeight: "500",
    color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.7)",
    marginBottom: "8px",
  };

  const isExpired =
    permissions.subscriptionEndDate &&
    new Date(permissions.subscriptionEndDate) < new Date();

  return (
    <div style={{
      background: theme === "light" ? "rgba(46,124,186,0.05)" : "rgba(46,124,186,0.1)",
      border: theme === "light" ? "1px solid #2e7cba" : "1px solid rgba(46,124,186,0.3)",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "24px",
    }}>
      <h4 style={{
        fontSize: "16px",
        fontWeight: "600",
        color: theme === "light" ? "#0f172a" : "#ffffff",
        marginBottom: "16px",
      }}>
        Subscription Details
      </h4>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))", gap: "16px" }}>
        <div>
          <label style={labelStyle}>Start Date</label>
          <input
            type="date"
            value={permissions.subscriptionStartDate
              ? new Date(permissions.subscriptionStartDate).toISOString().split('T')[0]
              : ''}
            onChange={(e) => onChange('subscriptionStartDate', e.target.value ? new Date(e.target.value) : null)}
            style={fieldStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>End Date</label>
          <input
            type="date"
            value={permissions.subscriptionEndDate
              ? new Date(permissions.subscriptionEndDate).toISOString().split('T')[0]
              : ''}
            onChange={(e) => onChange('subscriptionEndDate', e.target.value ? new Date(e.target.value) : null)}
            style={fieldStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>Subscription Tier</label>
          <select
            value={permissions.subscriptionTier || 'basic'}
            onChange={(e) => onChange('subscriptionTier', e.target.value)}
            style={fieldStyle}
          >
            <option value="basic">Basic</option>
            <option value="standard">Standard</option>
            <option value="premium">Premium</option>
            <option value="enterprise">Enterprise</option>
          </select>
        </div>
      </div>

      {isExpired && (
        <div style={{
          marginTop: "12px",
          padding: "8px 12px",
          borderRadius: "6px",
          background: "rgba(239,68,68,0.1)",
          border: "1px solid #ef4444",
          color: "#ef4444",
          fontSize: "13px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}>
          <AlertCircle size={16} />
          Subscription has expired
        </div>
      )}
    </div>
  );
};

export default SubscriptionDetails;